// @file Tldraw OnTheCanvas component
/* eslint-disable @typescript-eslint/promise-function-async */
import { createBridgeToReactState } from '@@/bits/vue_react_bridge'
import { CANVAS_HEIGHT, CANVAS_WIDTH } from '@@/bits/whiteboard_no_dependencies'
import { useWhiteboardCardTemplatesStore } from '@@/pinia/whiteboard_card_templates'
import React, { Suspense } from 'react'
import { computed } from 'vue'

const WhiteboardSuggestedCardTemplates = React.lazy(() => import('@@/reactcomponents/WhiteboardSuggestedCardTemplates'))

const ON_THE_CANVAS_SHARED_STYLE: React.CSSProperties = {
  position: 'absolute',
  top: -1,
  left: -1,
  zIndex: 0,
  /**
   * During resizing, tldraw's internal background sizing algorithm can create a small gap
   * (< 1px) between the background image and the container edges. This occurs because the
   * background ends up slightly smaller than the tl-container element.
   *
   * While we can't modify tldraw's internal sizing logic directly, we can compensate by
   * making our background 2px larger than the canvas dimensions. This ensures the background
   * fully covers any potential gaps without noticeable visual impact.
   *
   * @see tldraw's background sizing: https://github.com/tldraw/tldraw/blob/9d6b5916e83ef758dc7c28d3fc221fd4f0236b14/packages/editor/src/lib/components/default-components/DefaultCanvas.tsx#L86-L90
   */
  width: CANVAS_WIDTH + 2,
  height: CANVAS_HEIGHT + 2,
}

const whiteboardCardTemplatesStore = useWhiteboardCardTemplatesStore()

const useCanShowSuggestedCardTemplates = createBridgeToReactState(
  computed<boolean>(() => whiteboardCardTemplatesStore.canShowSuggestedCardTemplates),
)

const OnTheCanvas = (): React.JSX.Element => {
  const [canShowSuggestedCardTemplates] = useCanShowSuggestedCardTemplates()
  return canShowSuggestedCardTemplates ? (
    <Suspense>
      <WhiteboardSuggestedCardTemplates style={ON_THE_CANVAS_SHARED_STYLE} />
    </Suspense>
  ) : (
    <></>
  )
}

export default OnTheCanvas
